import React from 'react';
import loading from '../asset/loading.gif'
const Loading = () => {
    return (
        <div className='loading'>
           <img  src={loading} alt="" />
        </div>
    );
}

export default Loading;
